<template>
    <div class="logoBox" v-if="imageUrl">
        <img :src="imageUrl" alt="">
        <span style="color: white;">{{logoTitle}}</span>
    </div>
</template>

<script>
export default {
    data () {
        return {
            imageUrl: '',
            logoTitle: ''
        }
    },
    mounted () {
        if (this.appUtils.getAppId() == 'APPY301'){
            this.imageUrl = 'https://yjyp-ttcss.oss-cn-shenzhen.aliyuncs.com/images/yj-logo.png'
            this.logoTitle = '广东易教优培教育科技有限公司'
        } else if (this.appUtils.getAppId() == 'APPY302'){
            this.imageUrl = 'https://yjyp-ttcss.oss-cn-shenzhen.aliyuncs.com/images/yg-logo.png'
            this.logoTitle = '中央电化教育馆电化教育电子音像出版社'
        }
    }
}
</script>

<style lang="scss">
.logoBox{
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  img{
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue